import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import Chart from 'react-google-charts';
import axios from 'axios';
import { getCurrentYear, generateYears } from '../Util';
export default function VisitationMonthReport() {

    const VISITATION_BASE_URL = process.env.REACT_APP_VISITATION_BASE_URL;
    const VISITATION_GETALL = process.env.REACT_APP_VISITATION_SEARCH;
    const [paidVisitMonth, setPaidVisitMonth] = useState(); // Default to current month

    const [visitationData, setVisitationData] = useState([]);
    const [monthVisitationData, setMonthVisitationData] = useState([]);

    const years = generateYears(2020, new Date().getFullYear());

    const visitData = {
        siteName: "",
        year: "",
        month: "",
        status: "APPROVED"
    }

    const data = {
        month: "",
        year: ""
    }
    const [formData, setFormData] = useState(data);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const [group, ...keys] = name.split('.');
        if (keys.length >= 1) {
            const updatedFormData = { ...formData };
            let currentLevel = updatedFormData[group];
            keys.forEach((key, index) => {
                if (index === keys.length - 1) {
                    currentLevel[key] = value;
                } else {
                    currentLevel[key] = { ...currentLevel[key] };
                    currentLevel = currentLevel[key];
                }

            });
            setFormData(updatedFormData);
        } else {
            setFormData({ ...formData, [name]: value });

        }

    };

    const handleSubmit = (e) => {
        console.log(formData.month);
        setPaidVisitMonth(formData.month);
        setMonthVisitationData(visitationData.filter(
            (entry) => (entry.year === getCurrentYear() || entry.year === formData.year) && entry.month === formData.month));
    };

    // All Visitation records 
    useEffect(() => {

        const visitationAPI = VISITATION_BASE_URL + VISITATION_GETALL;
        if (visitationAPI)
            axios.post(visitationAPI, visitData)
                .then((response) => { setVisitationData(response.data); console.log(response.data) })
                .catch((error) => console.error(error))
    }, []);

    const getTotalPaid = (visitationData) => {
        const resultData = {};
        const totalYearValues = {};
        const paidFilteredData = visitationData.filter(
            (entry) => entry.month === paidVisitMonth);


        paidFilteredData.forEach(entry => {
            const { siteName, year, visitation } = entry;
            const totalValue = visitation.paid.totalPaid || 0;
            if (!resultData[siteName]) {
                resultData[siteName] = { [year]: totalValue };
            } else {
                resultData[siteName][year] = totalValue;
            }
            totalYearValues[year] = (totalYearValues[year] || 0) + totalValue;
        });

        const sortedYears = Array.from(new Set(paidFilteredData.map(entry => entry.year))).sort();
        const resultArray = [['SiteName', ...sortedYears, '% Change']]; // Get unique years

        Object.entries(resultData).forEach(([siteName, yearsData]) => {
            const rowData = [siteName, ...sortedYears.map(year => (yearsData[year] || 0)),
                calculatePercentageChange(yearsData)];
            resultArray.push(rowData);
        });

        // Add a row for total values
        const totalRow = ['Total', ...Object.values(totalYearValues), calculatePercentageChange(totalYearValues)];
        resultArray.push(totalRow);
        return resultArray;
    }





    const getTotalUnpaid = (visitationData) => {
        const resultData = {};
        const totalYearValues = {};

        const paidFilteredData = visitationData.filter(
            (entry) => entry.month === paidVisitMonth);


        paidFilteredData.forEach(entry => {
            const { siteName, year, visitation } = entry;
            const totalValue = visitation.unpaid.totalUnpaid || 0;

            if (!resultData[siteName]) {
                resultData[siteName] = { [year]: totalValue };
            } else {
                resultData[siteName][year] = totalValue;
            }
            totalYearValues[year] = (totalYearValues[year] || 0) + totalValue;

        });

        const sortedYears = Array.from(new Set(paidFilteredData.map(entry => entry.year))).sort();
        const resultArray = [['SiteName', ...sortedYears, '% Change']]; // Get unique years

        Object.entries(resultData).forEach(([siteName, yearsData]) => {
            const rowData = [siteName, ...sortedYears.map(year => (yearsData[year] || 0)), calculatePercentageChange(yearsData)];
            resultArray.push(rowData);
        });

        // Add a row for total values
        const totalRow = ['Total', ...Object.values(totalYearValues), calculatePercentageChange(totalYearValues)];
        resultArray.push(totalRow);
        return resultArray;
    }

    const calculatePercentageChange = (yearsData) => {
        const values = Object.values(yearsData);
        const len = values.length;
        if (len >= 2) {
            const percentageChange = ((values[len - 1] - values[len - 2]) / Math.abs(values[len - 2])) * 100;
            return parseFloat(isNaN(percentageChange) ? 0 : percentageChange.toFixed(2));
        }
        return 0;
    };

    const getAdmissionRevenue = (visitationData) => {
        const resultData = {};
        const totalYearValues = {};

        const paidFilteredData = visitationData.filter(
            (entry) => entry.month === paidVisitMonth);


        paidFilteredData.forEach(entry => {
            const { siteName, year, revenue } = entry;
            const total = parseFloat(revenue.totalAdmissionsRevenue) || 0.00;
            const phmcShare = parseFloat(revenue.phmcAdmissionShare) || 0.00;
            const associateShare = parseFloat(revenue.associateAdmissionShare) || 0.00;
            if (!resultData[siteName]) {
                resultData[siteName] = { [year]: { total: total, phmcShare: phmcShare, associateShare: associateShare } };
                console.log(`${siteName}: ${Object.values(resultData[siteName])}`);
            } else {
                resultData[siteName][year] = { total: total, phmcShare: phmcShare, associateShare: associateShare };
                console.log(resultData[siteName][year]);
            }
            totalYearValues[year] = {
                total: (totalYearValues[year] ? totalYearValues[year].total || 0 : 0) + total,
                phmcShare: (totalYearValues[year] ? totalYearValues[year].phmcShare || 0 : 0) + phmcShare,
                associateShare: (totalYearValues[year] ? totalYearValues[year].associateShare || 0 : 0) + associateShare
            };

        });

        const sortedYears = Array.from(new Set(paidFilteredData.map(entry => entry.year))).sort();
        const ar = sortedYears.flatMap(year => [`${year} total`, `${year} phmc`, `${year} associate`]);


        const resultArray = [['SiteName',
            ...sortedYears.flatMap(year => [`${year} Total`, `${year} PHMC Share`, `${year} Associate Share`])

        ]
        ];
        const totalYrChange = {}
        // Get unique years

        Object.entries(resultData).forEach(([siteName, yearsData]) => {
            console.log('data' + yearsData.total)
            const rowData = [siteName,
                ...Object.values(yearsData).flatMap(entry => [entry.total, entry.phmcShare, entry.associateShare]),
                // calculatePercentageChange(yearsData.total)
            ];
            resultArray.push(rowData);
        });

        // Add a row for total values
        const totalRow = ['Total',
            ...sortedYears.flatMap(year => totalYearValues[year] ? [totalYearValues[year].total || 0, totalYearValues[year].phmcShare, totalYearValues[year].associateShare] : 0),
            // calculatePercentageChange(totalYearValues[year].total)
        ];
        resultArray.push(totalRow);
        return resultArray;
    }


    const getEventTotalPaid = (visitationData) => {
        const resultData = {};
        const totalYearValues = {};
        const paidFilteredData = visitationData.filter(
            (entry) => entry.month === paidVisitMonth);


        paidFilteredData.forEach(entry => {
            const { siteName, year, eventsAdmissions } = entry;
            const totalValue = parseFloat(eventsAdmissions.visitorsPaid || 0);
            if (!resultData[siteName]) {
                resultData[siteName] = { [year]: totalValue };
            } else {
                resultData[siteName][year] = totalValue;
            }
            totalYearValues[year] = (totalYearValues[year] || 0) + totalValue;
        });

        const sortedYears = Array.from(new Set(paidFilteredData.map(entry => entry.year))).sort();
        const resultArray = [['SiteName', ...sortedYears, '% Change']]; // Get unique years

        Object.entries(resultData).forEach(([siteName, yearsData]) => {
            const rowData = [siteName, ...sortedYears.map(year => (yearsData[year] || 0)),
                calculatePercentageChange(yearsData)];
            resultArray.push(rowData);
        });

        // Add a row for total values
        const totalRow = ['Total', ...Object.values(totalYearValues), calculatePercentageChange(totalYearValues)];
        resultArray.push(totalRow);
        return resultArray;
    }

    const getEventTotalUnpaid = (visitationData) => {
        const resultData = {};
        const totalYearValues = {};
        const paidFilteredData = visitationData.filter(
            (entry) => entry.month === paidVisitMonth);


        paidFilteredData.forEach(entry => {
            const { siteName, year, eventsAdmissions } = entry;
            const totalValue = parseFloat(eventsAdmissions.visitorsUnPaid || 0);
            if (!resultData[siteName]) {
                resultData[siteName] = { [year]: totalValue };
            } else {
                resultData[siteName][year] = totalValue;
            }
            totalYearValues[year] = (totalYearValues[year] || 0) + totalValue;
        });

        const sortedYears = Array.from(new Set(paidFilteredData.map(entry => entry.year))).sort();
        const resultArray = [['SiteName', ...sortedYears, '% Change']]; // Get unique years

        Object.entries(resultData).forEach(([siteName, yearsData]) => {
            const rowData = [siteName, ...sortedYears.map(year => (yearsData[year] || 0)),
                calculatePercentageChange(yearsData)];
            resultArray.push(rowData);
        });

        // Add a row for total values
        const totalRow = ['Total', ...Object.values(totalYearValues), calculatePercentageChange(totalYearValues)];
        resultArray.push(totalRow);
        return resultArray;
    }

    const getEventRevenue = (visitationData) => {
        const resultData = {};
        const totalYearValues = {};
        const paidFilteredData = visitationData.filter(
            (entry) => entry.month === paidVisitMonth);


        paidFilteredData.forEach(entry => {
            const { siteName, year, eventsAdmissions } = entry;
            const totalValue = parseFloat(eventsAdmissions.totalEventRevenue) || 0;
            if (!resultData[siteName]) {
                resultData[siteName] = { [year]: totalValue };
            } else {
                resultData[siteName][year] = totalValue;
            }
            totalYearValues[year] = (totalYearValues[year] || 0) + totalValue;
        });

        const sortedYears = Array.from(new Set(paidFilteredData.map(entry => entry.year))).sort();
        const resultArray = [['SiteName', ...sortedYears, '% Change']]; // Get unique years

        Object.entries(resultData).forEach(([siteName, yearsData]) => {
            const rowData = [siteName, ...sortedYears.map(year => (yearsData[year] || 0)),
                calculatePercentageChange(yearsData)];
            resultArray.push(rowData);
        });

        // Add a row for total values
        const totalRow = ['Total', ...Object.values(totalYearValues), calculatePercentageChange(totalYearValues)];
        resultArray.push(totalRow);
        return resultArray;
    }

    // Report data table
    const paidVisitData = getTotalPaid(monthVisitationData);
    const paidVisitOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const paidVisitFormatters = [
        {
            type: "ArrowFormat",
            column: paidVisitData[0].length - 1,
        },
    ];
    const unpaidVisitData = getTotalUnpaid(monthVisitationData);
    const unpaidVisitOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const unpaidVisitFormatters = [
        {
            type: "ArrowFormat",
            column: unpaidVisitData[0].length - 1,
        },
    ];

    const admissionRevenue = getAdmissionRevenue(monthVisitationData);
    console.log(admissionRevenue);
    const admissionRevenueOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const admissionRevenueFormatters = [
        {
            type: "NumberFormat",
            column: 1,
            options: {
                prefix: "$"
            }
        },
        {
            type: "NumberFormat",
            column: 2,
            options: {
                prefix: "$"
            }
        },
        {
            type: "NumberFormat",
            column: 3,
            options: {
                prefix: "$"
            }
        },
        {
            type: "NumberFormat",
            column: 4,
            options: {
                prefix: "$"
            }
        },
        {
            type: "NumberFormat",
            column: 5,
            options: {
                prefix: "$"
            }
        },
        {
            type: "NumberFormat",
            column: 6,
            options: {
                prefix: "$"
            }
        },
        {
            type: "ArrowFormat",
            column: 7,
        },
    ];

    const eventPaidVisitData = getEventTotalPaid(monthVisitationData);
    console.log(eventPaidVisitData);
    const eventPaidVisitOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const eventPaidVisitFormatters = [
        {
            type: "ArrowFormat",
            column: eventPaidVisitData[0].length - 1,
        },
    ];

    const eventUnpaidVisitData = getEventTotalUnpaid(monthVisitationData);
    console.log(eventUnpaidVisitData)
    const eventUnpaidVisitOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const eventUnpaidVisitFormatters = [
        {
            type: "ArrowFormat",
            column: eventUnpaidVisitData[0].length - 1,
        },
    ];

    const eventRevenueData = getEventRevenue(monthVisitationData);
    console.log(eventRevenueData)
    const eventRevenueDataOptions = {
        showRowNumber: true,
        pageSize: 20,
    }
    const eventRevenueDataFormatters = [
        {
            type: "ArrowFormat",
            column: eventRevenueData[0].length - 1,
        }, {
            type: "NumberFormat",
            column: 1,
            options: {
                prefix: "$"
            }
        },
        {
            type: "NumberFormat",
            column: 2,
            options: {
                prefix: "$"
            }
        },
    ];

    const downloadCSV = () => {
        const combinedData = [
            ['Total Paid  Visitaion'],
            ...paidVisitData.map(row => row.join(',')),
            [''],
            ['Total Unpaid Visitation'],
            ...unpaidVisitData.map(row => row.join(',')),
            [''],
            ['Admissions Revenue'],
            ...admissionRevenue.map(row => row.join(',')),
            [''],
            ['Total Paid Event Attendance'],
            ...eventPaidVisitData.map(row => row.join(',')),
            [''],
            ['Total Unpaid Event Attendance'],
            ...eventUnpaidVisitData.map(row => row.join(',')),
            [''],
            ['Event Attendance Revenue'],
            ...eventRevenueData.map(row => row.join(',')),
            [''],

        ];

        // Convert the chart data to CSV format
        const csvContent = combinedData.join('\n');
        // Create a data URI for the CSV content
        const encodedUri = encodeURI('data:text/csv;charset=utf-8,' + csvContent);
        // Create a download link
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'VisitationMonthlyReport.csv');
        // Append the link to the document body and trigger the click event
        document.body.appendChild(link);
        link.click();
    };
    const createDownloadHandler = () => {
        return () => downloadCSV();
    };
    return (
        <>
            <span ><b>Visitation Monthly Overview </b> </span>
            <Row className="mb-0 main-content" >
                <Col>
                    <Card>
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>
                                <Row className="mb-0 main-content" >
                                    <Form.Group as={Col} >
                                        <Form.Label> Month</Form.Label>
                                        <Form.Select name="month" value={formData.month} onChange={handleInputChange}>
                                            <option value="">Select</option>
                                            <option>JANUARY</option>
                                            <option>FEBRAURY</option>
                                            <option>MARCH</option>
                                            <option>APRIL</option>
                                            <option>MAY</option>
                                            <option>JUNE</option>
                                            <option>JULY</option>
                                            <option>AUGUST</option>
                                            <option>SEPTEMBER</option>
                                            <option>OCTOBER</option>
                                            <option>NOVEMBER</option>
                                            <option>DECEMBER</option>
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="year">
                                        <Form.Label>Comparison Year</Form.Label>
                                        <Form.Select name="year" required value={formData.year} onChange={handleInputChange}>

                                            <option value="">Select</option>
                                            {years.map(year => (
                                                <option key={year} value={year}>{year}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Row>
                                <Row className="mb-3 main-content">
                                    <Col>
                                        <Form.Group >

                                            <Button variant="primary" type="button" name="submit" onClick={handleSubmit}>
                                                Search
                                            </Button>
                                        </Form.Group>
                                    </Col>

                                </Row>
                            </Form>

                        </Card.Body>


                    </Card>
                </Col>

            </Row>
            {monthVisitationData[0] &&
                <Row className="mb-0 main-content" >
                    <Col>
                        <Button onClick={createDownloadHandler()}>Download Data</Button>
                    </Col>
                    <Col />
                    <Col />
                    <Col />
                </Row>
            }
            {monthVisitationData[0] ? <>
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title>Total Paid Visitation</Card.Title>
                            <Card.Body>

                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={paidVisitData}
                                    options={paidVisitOptions}
                                    formatters={paidVisitFormatters}
                                    rootProps={{ 'data-testid': '1' }}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <Card.Title>Total Unpaid Visitation</Card.Title>
                            <Card.Body>

                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={unpaidVisitData}
                                    options={unpaidVisitOptions}
                                    formatters={unpaidVisitFormatters}
                                    rootProps={{ 'data-testid': '1' }}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title>Admissions Revenue</Card.Title>
                            <Card.Body>

                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={admissionRevenue}
                                    options={admissionRevenueOptions}
                                    formatters={admissionRevenueFormatters}
                                    rootProps={{ 'data-testid': '1' }}
                                />
                            </Card.Body>


                        </Card>
                    </Col>

                </Row>
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title>Total Paid Event Attendance</Card.Title>
                            <Card.Body>

                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={eventPaidVisitData}
                                    options={eventPaidVisitOptions}
                                    formatters={eventPaidVisitFormatters}
                                    rootProps={{ 'data-testid': '1' }}
                                />
                            </Card.Body>


                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <Card.Title>Total Unpaid Event Attendance</Card.Title>
                            <Card.Body>

                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={eventUnpaidVisitData}
                                    options={eventUnpaidVisitOptions}
                                    formatters={eventUnpaidVisitFormatters}
                                    rootProps={{ 'data-testid': '1' }}
                                />
                            </Card.Body>


                        </Card>
                    </Col>

                </Row>
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title> Event Attendance Revenue</Card.Title>
                            <Card.Body>

                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={eventRevenueData}
                                    options={eventRevenueDataOptions}
                                    formatters={eventRevenueDataFormatters}
                                    rootProps={{ 'data-testid': '1' }}
                                />
                            </Card.Body>


                        </Card>
                    </Col>


                </Row>
            </> : <Row className="mb-0 main-content" >No data found!</Row>}
        </>
    );
}